<script setup lang="ts">
import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useCrmMetadataStore} from '@/stores';
import {readField} from '@/crm/odata';
import type {EntityName, FieldDef} from '@/crm/spec/types';

interface IProps {
    record: any;
    entity: EntityName;
    def: FieldDef;
}

const props = defineProps<IProps>();

const metadataStore = useCrmMetadataStore();
const {entities} = storeToRefs(metadataStore);

const label = computed(() => {
    if (props.def.labelOverride) return props.def.labelOverride;
    // touch entities to keep computed reactive once metadata loads
    void entities.value;
    return metadataStore.getLabel(props.entity, props.def.field);
});

const value = computed(() => readField(props.record, props.def.field) ?? '-');
</script>

<template>
    <div class="field-label">{{ label }}</div>
    <div class="field-value" :class="{empty: value === '-'}">{{ value }}</div>
</template>

<style scoped>
.field-label {
    color: var(--color-text);
    opacity: 0.7;
    font-size: var(--font-size-body);
    white-space: nowrap;
}

.field-value {
    color: var(--color-text);
    font-size: var(--font-size-body);
    word-break: break-word;
}

.field-value.empty {
    opacity: 0.4;
}
</style>
